export const affiliateAttribute = async () => {
  // run this code on each page mount
  const url = new URL(window.location.href);
  const ref = url.searchParams.get("ref");
  if (!ref) return;

  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  fetch(`${process.env.NEXT_PUBLIC_ROOMS_DOMAIN_URL}/api/v1/affiliate/attribute`, {
    headers,
    method: "POST",
    body: JSON.stringify({ ref }),
  })
    .then((res) => res.json())
    .then((data) => {
      document.cookie = `introw__affiliate=${true}; path=/; max-age=${data.duration}; SameSite=Lax`;
      // Remove ref parameter from URL
      url.searchParams.delete("ref");
      window.history.replaceState({}, document.title, url.toString());
    })
    .catch((e) => console.error("[introw] error:", e));
};

export const affiliateConvert = (fields: Record<string, any>) => {
  // get cookie
  const affiliateCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("introw__affiliate="))
    ?.split("=")[1];

  if (!affiliateCookie) return;

  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  // if cookie exists, send to api
  fetch(`${process.env.NEXT_PUBLIC_ROOMS_DOMAIN_URL}/api/v1/affiliate/convert`, {
    headers,
    method: "POST",
    body: JSON.stringify({ fields }),
  }).catch((e) => console.error("[introw] error:", e));
};
